module.exports = __webpack_public_path__ + "static/media/box-side.afd28752.svg";